<template>
  <div ref="queryForm">
    <el-form
      :model="F_Data"
      ref="forms"
      :class="More ? 'glo_form hasMoreParam' : 'glo_form'"
      label-position="left"
    >
      <template v-for="(item, index) in F_config">
        <el-form-item
          class="queryItems"
          v-if="item.type === 'input'"
          :prop="item.field"
          :label="item.label"
          :key="index"
        >
          <el-input
            v-model="F_Data[item.field]"
            @keyup.enter.native="enterClick"
            :placeholder="item.placeholder"
            clearable
          />
        </el-form-item>
        <el-form-item
          class="queryItems"
          v-if="item.type === 'select'"
          :prop="item.field"
          :label="item.label"
          :key="index"
        >
          <el-select
            v-model="F_Data[item.field]"
            :placeholder="item.placeholder"
            clearable
            filterable
          >
            <el-option
              v-for="(option, num) in item.selectOptions"
              :label="option[item.setLabel] || option.label"
              :value="option[item.setValue] || option.val"
              :key="num"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          class="queryItems"
          v-if="item.type === 'selectloadmore'"
          :prop="item.field"
          :label="item.label"
          :key="index"
        >
          <el-select
            v-model="F_Data[item.field]"
            clearable
            remote
            filterable
            :remote-method="
              (query) => {
                remoteMethod(query, item.remotemethod);
              }
            "
            :loading="item.loading"
            v-loadmore:loadmore="item.loadmoreMethod"
            @change="change($event, item.selectChange)"
            @clear="remoteMethod('', item.remotemethod)"
            :placeholder="item.placeholder"
          >
            <el-option
              v-for="(option, num) in item.selectOptions"
              :label="option[item.setLabel] || option.label"
              :value="option[item.setValue] || option.val"
              :key="num"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          class="queryItems"
          style="width: 360px"
          v-if="item.type === 'doubleSelect'"
          :label="item.label"
          :key="index"
        >
          <el-row :gutter="20">
            <el-col
              :span="12"
              v-for="(selectItem, s_index) in item.selectItem"
              :key="s_index"
            >
              <!-- :filterable="selectItem.allowCreate" -->
              <el-select
                v-model="F_Data[selectItem.field]"
                :placeholder="selectItem.placeholder"
                clearable
                :allow-create="selectItem.allowCreate"
                filterable
                @change="change($event, selectItem.selectChange)"
              >
                <el-option
                  v-for="(option, num) in selectItem.selectOptions"
                  :label="option[selectItem.setLabel] || option.label"
                  :value="option[selectItem.setValue] || option.val"
                  :key="num"
                />
              </el-select>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item
          class="queryItemsTimes"
          v-if="item.type === 'timeSelect'"
          :key="index"
        >
          <slot :name="item.slotName" />
        </el-form-item>
      </template>
    </el-form>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    formConfig: {
      type: Array,
    },
    formData: {
      type: Object,
    },
    More: {
      type: Boolean,
    },
  },
  emits: ['changeCallback', 'EnterClick'],
  data() {
    return {
      F_config: this.formConfig,
      F_Data: this.formData,
    }
  },
  watch: {
    formConfig: {
      handler(newValue, oldValue) {},
      deep: true, // 默认值是 false，代表是否深度监听
    },
  },
  methods: {
    change(val, name) {
      if (name) {
        this.$emit('changeCallback', val, name)
      }
    },
    // 远程搜索
    remoteMethod(e, name) {
      this.$emit('changeCallback', e, name)
    },
    // 滚动条加载更多
    loadmore(e) {
      this.$emit('changeCallback', '', e)
    },
    enterClick() {
      this.$emit('EnterClick')
    },
  },
}
</script>
<style lang="less">
</style>
